import { CustomSelectOption } from '@lfg/ui/components';

import AdminSelect, { AdminSelectProps } from 'src/components/NodeSaleForm/AdminSelect';
import { fontWeightMap } from 'src/global/constants/font.constant';

interface FontWeightSelectProps extends Omit<AdminSelectProps, 'options'> {}

export function FontWeightSelect(props: FontWeightSelectProps) {
  const { value, ...rest } = props;
  return (
    <AdminSelect
      options={Object.entries(fontWeightMap).map(([value, label]) => ({ value, label }))}
      menuItemProps={(option: CustomSelectOption) => ({
        sx: {
          fontWeight: option.value,
        },
      })}
      value={value}
      sx={{
        fontWeight: value as number,
      }}
      {...rest}
    />
  );
}
